import { useTranslation } from "react-i18next";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export default function TouchPointsPage() {
  const { t } = useTranslation(["common", "social", "sidebar"]);
  return (
    <TrendzContainerCard
      title={t("social:touch_points_journey")}
    ></TrendzContainerCard>
  );
}
